import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "../../../../components/Breadcrumb";
import { Button, SaveButton } from "../../../../components/Buttons";

export const PaymentIn = () => {
    document.title = "Mədaxil";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Maliyyə", value: "/finance" },
        { name: "Ödənişlər", value: "/finance/payments" },
        { name: "Mədaxil", value: "/finance/payments/paymentin", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Mədaxil</h2>
                    <p>
                        Ödənişlər səhifəsində, sahibkar, <Link to="/customers/customer">tərəf-müqabillərdən</Link> (kontragent) <Button>Nağd</Button> və{" "}
                        <Button>Nağdsız</Button> şəkildə <Button>Mədaxil</Button> ( qəbul etdiyi ) ödənişləri qeyd edib <SaveButton /> düyməsini sıxmaq
                        lazımdır.
                        <b>Qeyd</b>: Xərc maddəsi olaraq <mark>məhsul alınması</mark> seçilməlidir.
                        <br />
                        Nümunədə Maliyyə ⮞ Ödənişlər ⮞ Mədaxil səhifəsinə keçid göstərilib.
                    </p>
                    <img src="/images/finance/payments/paymentin.gif" alt="Mədaxil" />
                </article>
            </div>
        </div>
    );
};
